'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.LinkBox.displayName = 'LinkBox';
Object.defineProperty(exports, 'LinkBox', {
  enumerable: true,
  get: function () {
    return react.LinkBox;
  }
});